module.exports = __webpack_public_path__ + "static/media/beach1.53f3f457.png";